import React, { useState } from 'react';
import { MessageSquare, CheckCircle } from 'lucide-react';
import { feedbackService } from '../services/api';

function Feedback() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    type: 'suggestion',
    message: '',
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await feedbackService.create({
        ...formData,
        subject: formData.type === 'other' ? 'سایر' : formData.type === 'bug' ? 'گزارش خرابی' : formData.type === 'complaint' ? 'شکایت' : 'پیشنهاد',
        date: new Date().toISOString().slice(0, 10),
      });
      setSubmitted(true);
      setTimeout(() => {
        setFormData({ name: '', email: '', type: 'suggestion', message: '' });
        setSubmitted(false);
      }, 3000);
    } catch (error) {
      console.error('Error sending feedback:', error);
    }
  };

  return (
    <div className="bg-gray-50 min-h-screen">
      <div className="bg-gradient-to-br from-blue-900 to-blue-800 text-white py-16">
        <div className="max-w-7xl mx-auto px-4">
          <h1 className="text-5xl font-bold mb-4">شکایات و پیشنهادات</h1>
          <p className="text-xl text-blue-100">نظرات و پیشنهادات شما برای ما مهم است</p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 py-16">
        <div className="bg-white rounded-xl shadow-md p-8">
          {submitted && (
            <div className="bg-green-50 border-r-4 border-green-600 text-green-800 p-6 rounded-lg mb-8 flex items-start gap-3">
              <CheckCircle size={24} className="flex-shrink-0 mt-0.5" />
              <div>
                <h3 className="font-bold mb-1">پیام شما با موفقیت ارسال شد</h3>
                <p>از نظرات شما متشکریم</p>
              </div>
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block text-sm font-bold text-gray-900 mb-2">نام شما *</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
                placeholder="نام کامل خود را وارد کنید"
              />
            </div>

            <div>
              <label className="block text-sm font-bold text-gray-900 mb-2">ایمیل شما *</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
                placeholder="ایمیل خود را وارد کنید"
              />
            </div>

            <div>
              <label className="block text-sm font-bold text-gray-900 mb-2">نوع پیام *</label>
              <select
                name="type"
                value={formData.type}
                onChange={handleChange}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
              >
                <option value="suggestion">پیشنهاد</option>
                <option value="complaint">شکایت</option>
                <option value="bug">گزارش خرابی</option>
                <option value="other">سایر</option>
              </select>
            </div>

            <div>
              <label className="block text-sm font-bold text-gray-900 mb-2">پیام شما *</label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
                rows="6"
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent resize-none"
                placeholder="پیام خود را وارد کنید"
              />
            </div>

            <button
              type="submit"
              className="w-full bg-gradient-to-r from-blue-700 to-blue-900 text-white py-4 rounded-lg font-bold hover:from-blue-800 hover:to-blue-950 transition shadow-lg hover:shadow-xl flex items-center justify-center gap-2"
            >
              <MessageSquare size={20} />
              ارسال پیام
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Feedback;
